module.exports = __webpack_public_path__ + "static/media/13PeterboroWhiteCoreMatboardBlueberryW568.6f09e6b2.png";